import React from 'react'
import styles from './TabMenuCrm.module.scss'
import { classNames as cn } from 'helpers'
import PropTypes from 'prop-types'

const TabMenuCrm = (props) => {
  return (
    <div className={styles.tabMenu}>
      <div className={styles.tabs}>
        {props.tabs.map((tab) => (
          <div
            key={tab.id}
            className={cn({
              [styles.tab]: true,
              [styles.active]: tab.id === props.tabID,
            })}
            onClick={() => props.onChange(tab)}
          >
            {tab.name}
            <div className={styles.count}>{tab.count}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

TabMenuCrm.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  tabID: PropTypes.number,
  onChange: PropTypes.func.isRequired,
}
export default TabMenuCrm
